import React from 'react'
import PropTypes from 'prop-types'
import { TimelineLite } from 'gsap/TimelineLite'
import Logo from '../components/Logo'
import CustomLink from '../components/CustomLink'

class AuthLayout extends React.Component {
    componentDidMount () {
        this.animate()
    }

    animate () {
        const tl = new TimelineLite()
        tl.fromTo(this.panel, 1, { y: '-100%' }, { y: '0%', ease: Bounce.easeOut }, '+=0.25')
    }

    render () {
        const UpperContent = (
            <div className='upper-content'>
                <div className='d-flex align-items-center logo-container px-4 px-lg-0'>
                    <Logo />
                    {this.props.backLinkLocation === 'login'
                        ? <CustomLink to='/login' className='d-inline-block ml-3 mt-lg-3 font-small pr-2 pr-lg-0'>Back to login</CustomLink>
                        : this.props.backLinkLocation === 'logout'
                            ? <CustomLink to='/logout' className='d-inline-block ml-3 mt-lg-3 font-small pr-2 pr-lg-0'>Logout</CustomLink>
                        : <a href='https://www.exetel.com.au' className='d-inline-block ml-3 mt-lg-3 font-small pr-2 pr-lg-0'>Back to exetel.com.au</a>}
                </div>
                <div className='mx-5 mx-lg-0 heading'>
                    <h1 className='mt-0 mb-2' dangerouslySetInnerHTML={{ __html: this.props.title }} />
                    {this.props.subTitle ? <p className='m-0 mb-4 font-large'>{this.props.subTitle}</p> : ''}
                    {this.props.description ? <p className='m-0 mb-4 mt-3 font-small' dangerouslySetInnerHTML={{ __html: this.props.description }} /> : ''}
                </div>
            </div>
        )

        const Content = (
            <React.Fragment>
                {UpperContent}
                <div className='lower-content'>
                    {this.props.children}
                </div>
            </React.Fragment>
        )

        return (
            <section className={`auth-layout ${this.props.className}`}>
                <div className='inner'>
                    <div className='row'>
                        <div className='d-none d-lg-block col-lg-7 offset-lg-1 mb-lg-5'>
                            <div className='panel' ref={el => this.panel = el}>
                                {Content}
                            </div>
                        </div>
                        <div className='col-12 d-lg-none no-relative'>
                            {Content}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

AuthLayout.propTypes = {
    title: PropTypes.string.isRequired,
    backLinkLocation: PropTypes.oneOf(['exetel', 'login', 'logout']),
    subTitle: PropTypes.string,
    description: PropTypes.string,
    className: PropTypes.string
}

AuthLayout.defaultProps = {
    className: '',
    backLinkLocation: 'login'
}

export default AuthLayout



// WEBPACK FOOTER //
// ./resources/js/auth/AuthLayout.js